const configList = {
  // 正在抽奖中的活动列表
  getConfig: `/v2/WeChat/getConfig`,
};

export default (baseApi: string) => {
  const obj = {};
  for (const key of Object.keys(configList)) {
    obj[key] = `${baseApi}${configList[key]}`;
  }
  return obj;
};
